import PropTypes from 'prop-types';
import './checkbox.scss';

export const Checkbox = (props) => {
    const { children, input, type, className, disabled, meta, required } = props;
    const error = meta?.error;
    const errorId = input?.name ? `error-checkbox-${input.name}` : undefined;

    return (
        <div className={`form-check form-checkbox ${className} d-flex flex-wrap align-items-start`}>
            <input
                className="form-check-input"
                type={type}
                id={type === 'radio' ? `${input.name}-${input.value}` : input.name}
                checked={input.value}
                disabled={disabled}
                aria-required={required ? 'true' : undefined}
                aria-invalid={error ? 'true' : undefined}
                aria-describedby={error ? errorId : undefined}
                {...input}
            />
            <label
                className="form-check-label ms-2"
                htmlFor={type === 'radio' ? `${input.name}-${input.value}` : input.name}
            >
                {children}
            </label>
            {error && (
                <small id={errorId} className="alert alert-danger invalid-feedback d-block w-100" role="alert">{error}</small>
            )}
        </div>
    );
};

Checkbox.propTypes = {
    children: PropTypes.node,
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.string,
    }).isRequired,
    type: PropTypes.oneOf(['checkbox', 'radio']),
    className: PropTypes.string,
};

Checkbox.defaultProps = {
    children: '',
    type: 'checkbox',
    className: '',
};
